import React, { useCallback, useEffect, useState } from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { Dropdown } from "primereact/dropdown";
import { row } from "@ui/style/layout";

interface DropdownOption<T> {
	label: string;
	key: T;
}

interface SortDropdownProps<T> {
	sortOptions: DropdownOption<T>[];
	onChange: (activeSortKey: T) => void;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
export const SortDropdown = <T,>({ sortOptions, onChange }: SortDropdownProps<T>): JSX.Element => {
	const { format } = useI18n();
	const [selectedOption, setSelectedOption] = useState<DropdownOption<T> | undefined>();
	const onSortChange = useCallback((e: { value: DropdownOption<T> }) => setSelectedOption(e.value), []);

	useEffect(() => {
		setSelectedOption(sortOptions.length > 0 ? sortOptions[0] : undefined);
	}, [sortOptions]);

	useEffect(() => selectedOption && onChange(selectedOption.key), [onChange, selectedOption]);

	return (
		<Container>
			<div>{format("templateListing.sortLabel")}</div>
			<Dropdown value={selectedOption} options={sortOptions} onChange={onSortChange} />
		</Container>
	);
};

const Container = styled.div`
	${row("XS", "flexstart", "center")}
`;
